import React from 'react';
import { motion } from 'framer-motion';
const screenshots = [{
  src: 'https://cdn.magicpatterns.com/uploads/imUXRqUU2wHJvvEX8mcWzy/testimonio_javi_valencia_quimica.webp',
  alt: 'Testimonio por WhatsApp de un docente sobre los proyectos ABP del MegaPack Química Visual'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iG6779ACs1rKeTYacg57P4/testimonio_ximena_cdmx_quimica.webp',
  alt: 'Testimonio por WhatsApp de la profesora Ximena de CDMX sobre las fichas ilustrativas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/swe7TWhkTb2mtEry4kPx66/testimonio_beatriz_medellin_quimica.webp',
  alt: 'Testimonio por WhatsApp de la profesora Beatriz de Medellín sobre el material organizado por niveles'
}];
export function WhatsAppTestimonials() {
  // Duplicate the list so the marquee can loop seamlessly.
  const loop = [...screenshots, ...screenshots];
  return <section className="py-8 md:py-16 px-4 overflow-hidden" data-id="element-267" data-mp="1c5h0mtxcpxx2">
      <div className="max-w-3xl mx-auto text-center mb-6 md:mb-10" data-id="element-268" data-mp="1c33a8ydm99vu">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-chem-navy mb-3 leading-tight" data-id="element-269" data-mp="sjwgeacvkf1p">
          Lo que dicen docentes que ya trabajan con recursos listos para usar.
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-chem-navy/70 font-bold text-sm md:text-lg leading-snug" data-id="element-270" data-mp="9ljtllt1j6nn">
          Docentes de distintos países de Latinoamérica utilizan Química Visual
          para preparar con más claridad, explicar mejor y reducir el tiempo de
          búsqueda de materiales.
        </motion.p>
      </div>

      <div className="relative" data-id="element-271" data-mp="1v196wj2kzm25">
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-8 md:w-24 z-10 bg-gradient-to-r from-chem-bg to-transparent" data-id="element-272" data-mp="1yyx1tm49xeu1" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-8 md:w-24 z-10 bg-gradient-to-l from-chem-bg to-transparent" data-id="element-273" data-mp="3w2yw7rhh09xg" />

        <div className="group flex overflow-hidden" data-id="element-274" data-mp="8woftxq5kglm">
          <motion.div className="flex gap-4 md:gap-6 shrink-0" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 45,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-275" data-mp="8ubvjdwx9u5e">
            {loop.map((shot, i) => <div key={i} className="shrink-0 w-[220px] md:w-[300px] rounded-3xl overflow-hidden bg-white border border-chem-petrol/12 shadow-xl shadow-chem-navy/10" data-id="element-276" data-mp="38ccoy2faitoi" data-mpi={i}>
                <img src={shot.src} alt={shot.alt} loading="lazy" decoding="async" className="w-full h-auto block" data-id="element-277" data-mp="3hbg8f7iddb3j" />
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}